import { render, staticRenderFns } from "./sys-content-header.vue?vue&type=template&id=2a0d8cea"
import script from "./sys-content-header.vue?vue&type=script&lang=ts"
export * from "./sys-content-header.vue?vue&type=script&lang=ts"
import style0 from "./sys-content-header.vue?vue&type=style&index=0&id=2a0d8cea&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports